module.exports = __webpack_public_path__ + "assets/img/APPROVAL_PLUGIN.82e691fe.svg";